module.exports = __webpack_public_path__ + "img/5.1ec4f1eb.png";